import React, { useState } from 'react';

import IconOnlyButton from 'components/Buttons/IconOnlyButton';
import LoadingZone from 'components/LoadingZone';
import usePostFeedback from './usePostFeedback';

const ThumbsUpThumbsDownFeedback = () => {
  const { postFeedback } = usePostFeedback();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const handleSubmitGoodBadFeedback = async (type) => {
    setIsSubmitting(true);
    try {
      await postFeedback(type);
      setHasSubmitted(true);
    } catch (error) {
      console.error('Error submitting thumbs up/down feedback:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return hasSubmitted ? (
    <div className='feedback__thanks t-paragraph--small'>
      Thanks for your feedback!
    </div>
  ) : (
    <>
      <div className='feedback__header t-paragraph'>How are we doing?</div>
      <div className='feedback__thumbButtons'>
        <LoadingZone isLoading={isSubmitting}>
          <IconOnlyButton
            sIcon='thumbsUp'
            sAriaLabel='Good'
            fnHandleClick={() => handleSubmitGoodBadFeedback('Thumbs up')}
            className='feedback__thumbButton--up'
          />
          <IconOnlyButton
            sIcon='thumbsDown'
            sAriaLabel='Bad'
            fnHandleClick={() => handleSubmitGoodBadFeedback('Thumbs down')}
            className='feedback__thumbButton--down'
          />
        </LoadingZone>
      </div>
    </>
  );
};

export default ThumbsUpThumbsDownFeedback;
